<script lang="ts" setup>

interface Properties {
  placeholder?: string;
  name?: string;
  type?: string;
  required?: boolean;
  value?: string;
  maxlength?: number;
  dataQa: string;
}

withDefaults(defineProps<Properties>(), {
  placeholder: () => '',
  name: () => '',
  type: () => 'text',
  required: () => false,
  maxlength: () => 524288,
  dataQa: () => '',
});
defineEmits(['update:value']);
</script>

<template>
  <input :name="name"
         :placeholder="placeholder"
         :required="required"
         :type="type"
         :value="value"
         :maxlength="maxlength"
         :data-qa="dataQa"
         class="shadow appearance-none border rounded border-gray-400 p-2 w-full"
         @input="$emit('update:value', ($event.target as HTMLInputElement).value)"/>
</template>
